import Multiselect from 'vue-multiselect';

import search from '@/components/search/index.vue';

import Api from '@/utils/api';

import {
  ROLE_QA_EXPERT,
  ROLE_PROOF_READER,
  ROLE_PROJECT_MNG,
} from '@/utils/const';

export default {
  components: {
    Multiselect,
    search,
  },
  data () {
    return {
      filter: {
        errorCategoryList: [],

        statusList: [{
          ID: 'non-modified',
          Name: 'Non-modified',
        }, {
          ID: 'modified',
          Name: 'Modified',
        }],

        roleList: [{
          ID: ROLE_PROJECT_MNG,
          Name: 'Project manager',
        }, {
          ID: ROLE_PROOF_READER,
          Name: 'Proofreader',
        }, {
          ID: ROLE_QA_EXPERT,
          Name: 'QA Expert',
        }],

        errorSeverityList: [{
          ID: 1,
          Name: 'Major',
        }, {
          ID: 2,
          Name: 'Minor',
        }],

        errorPointsList: [],
      },

      params: {
        ErrorCategory: '',
        Role: '',
        Status: '',
        ErrorSeverity: '',
        ErrorPoints: '',
        Query: '',
      },
    };
  },
  created () {
    this.getFilters();
  },
  methods: {
    getFilters () {
      Api.getMetrics()
        .then((data) => {
          if (data.data.Status) {
            this.filter.qaEvaluationTypeList = data.data.Data;

            var maxErrorPoints = Math.max.apply(Math, this.filter.qaEvaluationTypeList.map((item) => { return item.MaxErrorPoint; }));

            for (let i = 0; i <= maxErrorPoints; i++) {
              this.filter.errorPointsList.push({
                ID: i,
                Name: i + ' points',
              });
            }
          }
        });

      Api.getErrorCategories()
        .then((response) => {
          if (response.data.Status) {
            this.filter.errorCategoryList = response.data.Data;
          } else {
            this.$root.$emit('notification', {
              message: 'Error has occurred by loading error categories.',
              type: 'error',
              show: true,
            });
          }
        });
    },

    limitText (count) {
      return `and ${count} others`;
    },

    holderSearch (searchString) {
      this.params.Query = searchString;
    },

    sendFilters () {
      this.$emit('sendFilters', this.transformParams());
    },

    transformParams () {
      const params = {};

      for (const [name, value] of Object.entries(this.params)) {
        if (value !== null) {
          if (name === 'Query') {
            params[name] = this.$refs.child.search;
            continue;
          }

          if (typeof value === 'object' && value.length === 0) {
            params[name] = '';
          } else {
            if (typeof value === 'object') {
              if (value.length !== undefined) {
                if (name === 'Proofreaders' || name === 'QaExperts') {
                  params[name] = value.map((item) => item.UserId).join(',');
                  continue;
                }
                if (name === 'ErrorCategory') {
                  params[name] = value.map((item) => item.ID).join(',');
                  continue;
                }

                params[name] = value.map((item) => item.ID).join(',');
              } else {
                params[name] = value.ID;
              }
            } else {
              params[name] = value;
            }
          }
        } else {
          params[name] = '';
        }
      }

      return params;
    },

  },

};
